module.exports = __webpack_public_path__ + "img/905bbe885ca94505a8d91fc75e58005c-1440.f2d62c1a.jpg";